(function(){
angular.module('ui2.0Controllers').controller('saveFilePropController',saveFilePropController)

function saveFilePropController($scope,$timeout,docTreeService){
    $scope.docTreeService = docTreeService;
    //$scope.filesNeedToBeEdited =

    $scope.closesaveFPDialog = function(){
        /*docTreeService.selectedFilesForEdit= angular.copy(docTreeService.selectedFilesForEditCopy);
        docTreeService.filePropList = angular.copy(docTreeService.tempfilePropList);
        docTreeService.contractDocuments = _.unionWith(docTreeService.selectedFilesForEdit,docTreeService.contractDocuments, function (aobj, oobj) {
           if(aobj.hasOwnProperty('id') && oobj.hasOwnProperty('id')){
               return (aobj.id == oobj.id);
           }else if(aobj.hasOwnProperty('filekey') && oobj.hasOwnProperty('filekey')){
               return (aobj.filekey == oobj.filekey);
           }

        });*/
        docTreeService.modalInstance.close();

    };

    $scope.getFileId = function(elmObj){
        var elmId = elmObj.filekey != null ? elmObj.filekey : elmObj.id;
        return 'jx-docInEditMode-'+elmId;
    };

    
    $scope.saveFPProp = function(){
        const invalidDocIdFileNames = [],
              invalidExtIdFileNames = [];
        docTreeService.selectedFilesForEdit.forEach(file => {
            file.documentId = file['documentId'] || "";
            file.documentId.length && !docTreeService.validIDFieldcheck({ id: file.documentId, type: 'documentId' }) && invalidDocIdFileNames.push(`${file.name}.${file.extension}`);
            file.externalId = file['externalId'] || "";
            file.externalId.length && !docTreeService.validIDFieldcheck({ id: file.externalId, type: 'externalId' }) && invalidExtIdFileNames.push(`${file.name}.${file.extension}`);
        });
        const createErrorToast = function (type, invalidFileNames) {
            const errorMsgs = {
                'documentId': window.intl_msg[36018] || "Ensure 'Document ID' is ≤ 128 characters and contains only letters, numbers, ., -, @, and _ (no spaces) for %s.",
                'externalId': "Ensure 'External ID' is ≤ 20 characters and contains only letters, numbers, -, @, and _ for %s."
            }
            toasterLabelTemplate = errorMsgs[type];
            const invalidFileNamesStr = invalidFileNames.reduce((acc, crr, idx, arr) => acc += `'${crr}'${idx !== arr.length -1 ? ', ' : ''}`, "");
            const toasterLabel = toasterLabelTemplate.replace('%s', invalidFileNamesStr);
            Toaster.create(toasterLabel, { iconClass: "icon-Information_filled" });
        }
        if(invalidDocIdFileNames.length || invalidExtIdFileNames.length) {
            invalidDocIdFileNames.length && createErrorToast("documentId", invalidDocIdFileNames);
            invalidExtIdFileNames.length && createErrorToast("externalId", invalidExtIdFileNames);
            return false;
        }
        docTreeService.saveFpProp = true;
        var filesWithCNOn = _.filter(docTreeService.selectedFilesForEdit, function (ob) {
            return ((docTreeService.allowedExtForCustomNumbering.indexOf(ob.extension.toLowerCase())>-1) && ob.customNumbering && (SirionUtils.isEmpty( ob.startPageNumber )|| SirionUtils.isEmpty( ob.numberOfPagesToExclude ) || ((ob.startPageNumber) > parseInt(ob.totalPages)) || ((ob.startPageNumber) == 0) || ((ob.startPageNumber) < 0) || ((ob.startPageNumber) > 100000) || ((ob.numberOfPagesToExclude) > parseInt(ob.totalPages)) || ((ob.numberOfPagesToExclude) == 0) || ((ob.numberOfPagesToExclude) < 0)) || ((ob.numberOfPagesToExclude) > 100000)) ;
        });
            if(!filesWithCNOn.length){
                docTreeService.modalInstance.close();
            }else{
                for(let i =0 ;i<filesWithCNOn.length;i++){
                    $timeout(function(){
                        const elList = $('#' + $scope.getFileId(filesWithCNOn[i])).find('.jx-cndepfield');
                        elList.map(function (index, el) {
                            $(el).keyup();
                        })
                    });
                }
                $timeout(()=> {
                    if (docTreeService.isPropertiesValid)
                        docTreeService.modalInstance.close()
                },100);
            }

            if (docTreeService.uploadScope) {
                docTreeService.uploadAllFiles(docTreeService.uploadScope.data, docTreeService.uploadScope);
            }
    };
}
saveFilePropController.$inject = ['$scope','$timeout','docTreeService'];

})();
mySmApp.filter('fileNameFilter', function() {
    return function(item) {
        return item.replace(/&amp;/g, '&');
    }
});
